import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "price-row__text" }

import BasePrice from '@lmt-rpb/Atoms/BasePrice/BasePrice.vue';
import type { Props as BasePriceProps } from '@lmt-rpb/Atoms/BasePrice/BasePrice.vue';

type Props = {
	priceProps: BasePriceProps;
	text?: string;
	fontSize?: 'extralarge' | 'large' | 'medium' | 'small';
};


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceRow',
  props: {
    priceProps: {},
    text: { default: 'Gesamtpreis' },
    fontSize: { default: 'medium' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['price-row', `price-row--${_ctx.priceProps.theme}`, `price-row--${_ctx.fontSize}`])
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.text), 1 /* TEXT */),
    _createVNode(BasePrice, _mergeProps({ class: "price-row__price" }, _ctx.priceProps), null, 16 /* FULL_PROPS */)
  ], 2 /* CLASS */))
}
}

})